import React from "react"
import { Tag, TagProps } from "@blueprintjs/core"
import classNames from "utils/classNames"
/* Custom Props

small - used to make the tag small (appropriate for notifications)
dark - used to make the tag dark
*/

export interface CustomTagProps extends TagProps {
  small?: boolean
  dark?: boolean
}
const CustomTag = ({
  active,
  intent,
  minimal,
  fill,
  icon,
  interactive,
  multiline,
  large,
  onClick,
  onRemove,
  rightIcon,
  round,
  className,
  small,
  children,
  dark,
  ...otherCustomProps
}: CustomTagProps) => {
  return (
    <Tag
      className={classNames(
        "vt-custom-tag",
        { "vt-custom-tag-small": small, "vt-custom-tag-dark": dark },
        className
      )}
      active={active}
      intent={intent}
      minimal={minimal}
      fill={fill}
      icon={icon}
      interactive={interactive}
      large={large}
      multiline={multiline}
      onClick={onClick}
      onRemove={onRemove}
      rightIcon={rightIcon}
      round={round}
      {...otherCustomProps}
    >
      {children}
    </Tag>
  )
}

export default CustomTag
